const styles = (theme) => ({
  title: {
    textAlign: 'center',
    padding: theme.spacing(0.5),
  },
  textBody: {
    textAlign: 'center',
    padding: theme.spacing(2),
  },
  button: {
    display: 'flex',
    margin: theme.spacing(2, 'auto'),
    width: '50%',
  },
  limitButton: {
    margin: theme.spacing(0.5),
    '&:last-child': {
      backgroundColor: theme.color.grey_medium,
      color: theme.color.black_80,
    },
  },
  redInfo: {
    color: theme.color.red_dark,
  },
});

export default styles;
